import { useId } from 'react'
import { FieldError, FieldErrors, Path, PathValue, UseFormSetValue } from 'react-hook-form'

import * as fileUpload from '@zag-js/file-upload'
import { normalizeProps, useMachine } from '@zag-js/react'

import Icon from '../Icon/IconView'

import styles from './FileUpload.module.css'

export function FileUpload<T extends Record<string, any>>({
  name,
  description,
  setValue,
  errors,
}: {
  description: string
  name: Path<T>
  setValue: UseFormSetValue<T>
  errors: FieldErrors<T>
}) {
  const [state, send] = useMachine(
    fileUpload.machine({
      id: useId(),
      accept: ['image/*'],
      onFileChange(files) {
        setValue(name, files.acceptedFiles as PathValue<T, Path<T>>, { shouldValidate: true })
      },
    })
  )

  const api = fileUpload.connect(state, send, normalizeProps)

  return (
    <div {...api.getRootProps()}>
      <div {...api.getDropzoneProps()}>
        <input {...api.getHiddenInputProps()} />
      </div>

      <button className={styles.button} {...api.getTriggerProps()}>
        <Icon icon='upload' width={20} height={20} />
        {description}
      </button>

      <ul {...api.getItemGroupProps()} className={styles.fileList}>
        {api.acceptedFiles.map(file => (
          <li key={file.name} {...api.getItemProps({ file })}>
            <div {...api.getItemNameProps({ file })}>{file.name}</div>
            <button {...api.getItemDeleteTriggerProps({ file })} className={styles.deleteButton}>
              <Icon icon='trash-full' width={16} height={16} />
            </button>
          </li>
        ))}
      </ul>

      {errors[name] && <p className={styles.error}>{(errors[name] as FieldError).message}</p>}
    </div>
  )
}
